package com.tovtalk.data.cache

import coil3.intercept.Interceptor
import coil3.request.ImageResult

class S3CacheKeyInterceptor : Interceptor {
    override suspend fun intercept(chain: Interceptor.Chain): ImageResult {
        val request = chain.request
        val url = request.data as? String ?: return chain.proceed()

        if (S3CacheKeyResolver.isSignedUrl(url)) {
            val cacheKey = S3CacheKeyResolver.resolve(url)
            val newRequest = request.newBuilder()
                .memoryCacheKey(cacheKey)
                .diskCacheKey(cacheKey)
                .data(url)
                .build()
            return chain.withRequest(newRequest).proceed()
        }
        return chain.proceed()
    }
}
